import { render, staticRenderFns } from "./InputDateField.vue?vue&type=template&id=25c4c476"
import script from "./InputDateField.vue?vue&type=script&lang=js"
export * from "./InputDateField.vue?vue&type=script&lang=js"
import style0 from "./InputDateField.vue?vue&type=style&index=0&id=25c4c476&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports